export const getInfoTextByDocumentType = (documentType?: string) => {
  switch (documentType) {
    case "1040":
      return "For form 1040, the monthly income is estimated by dividing annual income by 12 months";
    case "bank_statement":
      return "For bank statements, the gross monthly income is estimated by multiplying net monthly income by 1.2";
    case "w2":
      return "For form W-2, the monthly income is estimated by dividing annual income by 12 months";
    default:
      return "";
  }
};
